import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CREATE_SERVICE_FAILED_NETWORK_ERROR,
  CREATE_SERVICE_NAME_INVALID_ERROR
} from '../../../constants';
import { IService } from '../../../models/index';

export interface Service {
  isLoading: boolean;
  serviceErrorMessage: string;
  serviceDetails: IService[];
}

/**
 * Initial Service state in store
 */
const initialState: Service = {
  isLoading: false,
  serviceErrorMessage: '',
  serviceDetails: []
};

const getServiceNameSlice = createSlice({
  name: 'getServiceName',
  initialState,
  reducers: {
    getServiceNameStarted: (state) => {
      state.isLoading = true;
    },

    getServiceNameSuccess: (
      state,
      action: PayloadAction<IService[]>
    ) => {
      state.isLoading = false;
      state.serviceDetails = action.payload;
      state.serviceErrorMessage = CREATE_SERVICE_NAME_INVALID_ERROR;
    },

    getServiceNameFail: (state) => {
      state.isLoading = false;
      state.serviceDetails = initialState.serviceDetails;
      state.serviceErrorMessage = CREATE_SERVICE_FAILED_NETWORK_ERROR;
    },

    clearServiceDetails: (state) => {
      state.isLoading = false;
      state.serviceDetails = initialState.serviceDetails;
      state.serviceErrorMessage = '';
    }
  }
});
export const {
  getServiceNameStarted,
  getServiceNameSuccess,
  getServiceNameFail,
  clearServiceDetails
} = getServiceNameSlice.actions;
export default getServiceNameSlice.reducer;
